import styled from 'styled-components'

export const TableDiv = styled.div`
  width: 100%;

  table, th, td {
    border: 0.063rem solid var(--c6);
    border-collapse: collapse;
    font-family: 'Roboto','sans-serif';
  }

  table {
    width: 100%;
    table-layout: fixed;
  }

  th, td {
    padding: .2rem .3rem;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
  }

  th:first-child, td:first-child {
    width: 5rem;
    text-align: left;
    font-weight: 600;
  }

  th {
    background: var(--Azul);
    color: var(--c1);
    font-weight: 500;
  }

  tr:nth-child(even) td {
    background-color: var(--c3);
  }
`
